exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-menu{margin:0;padding:5px 20px}.search-menu input{width:100%}#sidebar-menu>li>a.sfActive{border-color:#ddd;border-width:1px}#sidebar-menu>li>a>span{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:inline-block}#page-sidebar{max-height:1000px;overflow-y:scroll}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/navigation/navigation.scss
// module id = 967
// module chunks = 0